import { render, staticRenderFns } from "./FormDropdown.vue?vue&type=template&id=316deb92"
import script from "./FormDropdown.vue?vue&type=script&lang=ts"
export * from "./FormDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports